import React from 'react';
import IconContainer from './icon_container';

export default function(props) {
  return (
    <IconContainer {...props}>
      <g
        className="copyIcon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="translate(-1203.000000, -266.000000)">
          <g id="Copy-Icon" transform="translate(1204.000000, 267.000000)">
            <polygon points="12.1428571 1.67735654 12.1428571 12.1153846 3 12.1153846 3 0 10.6313892 0" />
            <polygon
              fill="#FFFFFF"
              points="9.14285714 4.67735654 9.14285714 15.1153846 0 15.1153846 0 3 7.63138919 3"
            />
          </g>
        </g>
      </g>
    </IconContainer>
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/copy_icon.jsx